import produce from 'immer';
import type { Reducer } from 'redux';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import type { DealProposalState } from './types';
import { getInitialDealProposalState } from './initialState';
import { DEAL_PROPOSAL_FETCH_REQUEST, DEAL_PROPOSAL_FETCH_SUCCESS, DEAL_PROPOSAL_FETCH_FAILURE } from './actionTypes';
import { FETCH_DEAL_SUCCESS } from '../actionTypes';

export const dealProposalReducer: Reducer<DealProposalState> = (state = getInitialDealProposalState(), action: any) => {
    if (action.type === initActionTypes.INIT_PENCIL_SUCCESS || action.type === FETCH_DEAL_SUCCESS) {
        return getInitialDealProposalState();
    }

    return produce(state, (draft) => {
        switch (action.type) {
            case DEAL_PROPOSAL_FETCH_REQUEST: {
                draft.requestStatus = ApiRequestStatus.Loading;
                draft.isError = false;
                draft.errorMessage = undefined;
                break;
            }

            case DEAL_PROPOSAL_FETCH_SUCCESS: {
                draft.requestStatus = ApiRequestStatus.Success;
                draft.deals = action.payload?.deals;
                draft.printConfig = action.payload?.printConfig;
                draft.isError = false;
                draft.errorMessage = undefined;
                break;
            }

            case DEAL_PROPOSAL_FETCH_FAILURE: {
                draft.requestStatus = ApiRequestStatus.Error;
                draft.isError = true;
                break;
            }

            default:
                break;
        }
    });
};
